// extracted by mini-css-extract-plugin
module.exports = {"FModalBody":"FModalBody___1JWMR","tip":"tip___37l5c","wrapClassName":"wrapClassName___1Nk3m","FInput":"FInput___1n3i1","errorTip":"errorTip___Rjwsu"};